/* =============================================================================
   WH-154 · PostHog ↔ dataLayer bridge (storefront)
   -----------------------------------------------------------------------------
   Mirrors the storefront's existing window.dataLayer events (pushed by
   analytics-custom.js — select_item, search, pdp_*, book_consult_click,
   newsletter_signup, login, etc.) into PostHog, so we don't re-instrument.

   Runs only when snippets/posthog-init.liquid has loaded window.posthog.
   MUST load BEFORE analytics-custom.js so dataLayer.push is wrapped before any
   custom event fires. GTM's own push is preserved (we still call the original).

   Privacy: health brand. A denylist strips any PII/PHI keys before forwarding —
   mirrors the scrub posture of capi-custom.js. GTM housekeeping events (gtm.*)
   and gtag() argument-array pushes are ignored.
   ============================================================================= */
(function () {
  'use strict';

  if (!window.posthog) return;
  var SITE = document.currentScript && document.currentScript.getAttribute('data-site-base');

  /* WH-328: eh_id — the identity key everhope.care hands off (cookie / ?eh_id=,
     read by marketing-params-custom.js, which loads first). Super-prop on every
     store event: the warehouse join key. eh_id is a pseudonymous UUIDv7 — not PHI.

     WH-716: NO identify() here any more. The store shares everhope.care's PostHog
     project and cookie, so store events already land on the visitor's person, and
     the person is identified only by everhope.care, after OTP, with the phone-based
     everhope_id. identify(eh_id) on a browser already identified that way would
     switch it to a second person and split the visitor; merges cannot be undone. */
  var mint = null;
  try {
    var mp = window.everhopeMarketingParams;
    var ehId = mp && mp.ehId();
    if (ehId) posthog.register({ eh_id: ehId });
    // WH-761 M-13: a store-first visitor has no cookie yet; the site mints it, as on the LPs (lp-posthog.liquid)
    else if (mp && SITE) {
      mint = fetch(SITE + '/api/eh-id', { method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' }, body: '{}' })
        .then(function (r) { var id = r.ok && mp.ehId(); if (id) posthog.register({ eh_id: id }); })
        .catch(function () {});
    }
  } catch (e) {
    // Identity is best-effort; the order's _eh_id attribute is the durable key.
  }
  // WH-761 M-13: releases the first $pageview that posthog-init.liquid holds
  Promise.resolve(mint).then(function () { if (window.ehIdSettled) window.ehIdSettled(); });

  // Never forward these keys to PostHog as event properties.
  var PII_KEYS = {
    email: 1, phone: 1, first_name: 1, last_name: 1, name: 1, full_name: 1,
    address: 1, address1: 1, address2: 1, city: 1, region: 1, province: 1,
    state: 1, zip: 1, postal_code: 1, dob: 1, gender: 1,
    // capi-custom.js forbidden set (short forms)
    em: 1, ph: 1, fn: 1, ln: 1, ct: 1, st: 1, zp: 1, ge: 1, db: 1,
    content_name: 1
  };

  // GTM's internal bookkeeping events — not meaningful as PostHog events.
  function isInternalEvent(name) {
    return typeof name !== 'string' || name === '' || name.indexOf('gtm.') === 0;
  }

  function scrub(obj) {
    var out = {};
    for (var k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      if (k === 'event' || k === 'eventCallback' || k === 'eventTimeout') continue;
      if (PII_KEYS[k]) continue;
      out[k] = obj[k];
    }
    return out;
  }

  var dl = (window.dataLayer = window.dataLayer || []);
  var origPush = dl.push.bind(dl);

  dl.push = function (obj) {
    try {
      if (obj && !isInternalEvent(obj.event) && window.posthog && typeof posthog.capture === 'function') {
        posthog.capture(obj.event, scrub(obj));
      }
    } catch (e) {
      // Never let a capture error break the dataLayer (GTM/GA4 must keep working).
    }
    return origPush(obj);
  };
})();
